/*
* This file contains constants used as a prefixes to all endpoints in KSA.
* */
export const API_KSA_CORE_V1='/api/ksa-core/v1';
